module.exports = __webpack_public_path__ + "static/media/Kiosk_Slanted.ee1cf5a6.png";